<template>
  <div>
    <alarm-popup :show-modal="showModal" :close-fn="closePopup">
      <template v-if="modalType === ALARM_POPUP_TYPE_ALL" v-slot:popup-body>
        <alarm-popup-body></alarm-popup-body>
      </template>
      <template v-else-if="modalType === ALARM_POPUP_TYPE_LIVE" v-slot:popup-body>
        <alarm-popup-body-live></alarm-popup-body-live>
      </template>
    </alarm-popup>
  </div>
</template>
<script>
import {
  ALARM_POPUP_TYPE_ALL,
  ALARM_POPUP_TYPE_LIVE,
  HIDE_ALARM_POPUP,
  SHOW_ALARM_POPUP
} from '@/common/resources/const'
import AlarmPopup from '@/components/mypooq/AlarmPopup'
import AlarmPopupBody from '@/components/mypooq/AlarmPopupBody'
import AlarmPopupBodyLive from '@/components/mypooq/AlarmPopupBodyLive'
import { setDisableScrolling } from '@/common/utils/common'

export default {
  name: 'AlarmPopupWrapper',
  components: { AlarmPopupBodyLive, AlarmPopupBody, AlarmPopup },
  data () {
    return {
      ALARM_POPUP_TYPE_LIVE,
      ALARM_POPUP_TYPE_ALL,
      showModal: false,
      modalType: null
    }
  },
  methods: {
    closePopup () {
      this.$events.$emit(HIDE_ALARM_POPUP)
    },
    changeModalState (isVisible) {
      this.showModal = isVisible
    },
    setModalType (modalType) {
      this.modalType = modalType
    },
    eventRegister () {
      this.$events.$on(SHOW_ALARM_POPUP, type => {
        this.modalType = type
        this.changeModalState(true)
        setDisableScrolling(true)
      })
      this.$events.$on(HIDE_ALARM_POPUP, () => {
        this.changeModalState(false)
        setDisableScrolling(false)
      })
    },
    eventRemover () {
      this.$events.$off(SHOW_ALARM_POPUP)
      this.$events.$off(HIDE_ALARM_POPUP)
    }
  },
  mounted () {
    this.eventRegister()
  },
  beforeDestroy () {
    this.eventRemover()
  }
}
</script>
